import { parseISO } from 'date-fns';

export const alphabeticSortFn =
  (firstDataIndex: string, secondDataIndex?: string) =>
  (a: Record<string, any>, b: Record<string, any>): number => {
    const string1 = secondDataIndex
      ? a[firstDataIndex][secondDataIndex]
      : a[firstDataIndex] || '';
    const string2 = secondDataIndex
      ? b[firstDataIndex][secondDataIndex]
      : b[firstDataIndex] || '';
    return string1.localeCompare(string2);
  };

export const numericSortFn =
  (dataIndex: string) => (a: Record<string, any>, b: Record<string, any>): number => {
    const num1 = a[dataIndex] || 0;
    const num2 = b[dataIndex] || 0;
    return num1 - num2;
  };

export const dateSortFn =
  (dataIndex: string) => (a: Record<string, any>, b: Record<string, any>): number => {
    const date1 =
      typeof a[dataIndex] === 'string'
        ? parseISO(a[dataIndex])
        : new Date(a[dataIndex]);
    const date2 =
      typeof b[dataIndex] === 'string'
        ? parseISO(b[dataIndex])
        : new Date(b[dataIndex]);
    return date1.getTime() - date2.getTime();
  };
